import * as React from "react";
import styled, { css } from "../../../styled/index";
import darken from "polished/lib/color/darken";
import {CS} from "../../../styles/index";

const ROUND_LEFT = "3px 0 0 3px";
const ROUND_RIGHT = "0 3px 3px 0";

const InputGroupComponent = styled("div")`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;

const InputGroupIcon = styled("div")<{ side?: "left" | "right"; color?: "primary" }>`
  ${CS.flex.center};
  text-align: center;
  padding: 0 8px;
  height: ${({theme}) => theme.input.height}px;
  min-width: ${({theme}) => theme.input.height}px;
  font-size: ${({theme}) => theme.input.fontSize}px;
  ${({color, theme}) => color === "primary" ? css`
    background-color: ${theme.colors.primary};
    color: white;
    border: none;
  ` : (color === "input" ? css`
    background-color: white;
    color: ${theme.input.text};
    border: 1px solid ${theme.input.border};
  ` : css`
    background-color: ${darken(0.07, theme.input.background)};
    color: ${theme.input.text};
    border: 1px solid ${theme.input.border};
  `)};
  border-radius: ${({side}) => side === "right" ? ROUND_RIGHT : ROUND_LEFT};
  ${({side}) => side === "right" ? "border-left: none" : "border-right: none"};
  i, svg, img {
    font-size: 16px;
    vertical-align: middle;
  }
`;

const InputGroupField = styled("div")<{ side?: "left" | "right" }>`
  flex-grow: 1;
  border-radius: ${({side}) => side === "right" ? ROUND_LEFT : ROUND_RIGHT};
  input {
    border-radius: ${({side}) => side === "right" ? ROUND_LEFT : ROUND_RIGHT};
    box-shadow: none;
  }
`;

export interface InputGroupProps {
  icon?: React.ReactNode;
  base64?: string;
  iconHtml?: React.ReactNode;
  className?: string;
  iconStyle?: React.CSSProperties;
  children?: React.ReactNode;
  side?: "left" | "right";
  color?: "primary" | "input";
  hide?: boolean;
}

export const InputGroup = (props: InputGroupProps) => {

  const icon = (
    <InputGroupIcon side={props.side}>
      {props.base64 && <img src={props.base64} style={props.iconStyle}/>}
      {!!props.icon && props.icon}
      {!!props.iconHtml && props.iconHtml}
    </InputGroupIcon>
  );

  return (
    <InputGroupComponent className={props.className}>
      {(props.side !== "right" && !props.hide) && icon}
      <InputGroupField side={props.side}>
        {props.children}
      </InputGroupField>
      {(props.side === "right" && !props.hide) && icon}
    </InputGroupComponent>
  );
};
